import { useState } from "react";
import axios from "axios";

const usePut = (url) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const token = JSON.parse(sessionStorage.getItem("userData"));
  const access_token = token ? token.access_token : null;
  const putData = async (putData) => {
    setError(null);
    try {
      setLoading(true);
      const response = await axios.put(url, putData, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      // When the body is empty (e.g. 204), still set a truthy value so callers
      // can tell success apart from the initial null state.
      const payload =
        response?.data !== undefined && response?.data !== null
          ? response.data
          : {};
      setData(payload);
      return payload;
    } catch (err) {
      setError(err);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, putData };
};

export default usePut;
